var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWwStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.2506 35.338C55.4073 28.5357 48.1891 23.8248 40.1051 24.8254C32.0323 25.8261 26.6805 36.3724 27.5237 43.1746C27.8723 45.9967 30.537 47.9868 33.4715 47.627C36.406 47.2672 38.5085 44.6813 38.16 41.8704C37.3167 35.0682 29.57 26.1297 21.4973 27.1191C13.4133 28.1085 7.54423 34.4273 8.38749 41.2295C10.1077 55.1826 30.6269 63.5027 35.3604 62.918C40.0938 62.3334 57.9708 49.2798 56.2506 35.338Z",
    fill: "white",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.072 12.424L25.2863 16.9663",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6885 66.9993L39.8353 71.2831",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4114 20.3168L13.7282 23.6336",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3591 60.2646L53.496 63.4015",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51855 33.9775L7.06088 35.1918",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.094 48.5939L61.3777 49.7408",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51855 49.7408L7.06088 48.5265",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.094 35.1244L61.3777 33.9775",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4114 63.4015L13.7282 60.0847",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3591 23.4537L53.496 20.3168",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.072 71.2831L25.2863 66.752",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6885 16.7189L39.8353 12.424",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3354 31.2679L28.0299 36.6647L27.5127 43.1634C27.5127 43.1634 28.772 47.8969 33.4604 47.6158C38.1489 47.3347 38.1489 41.8592 38.1489 41.8592L36.4399 36.3724L34.3374 33.674L31.3354 31.2679Z",
    fill: "#63C7C9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2506 35.338C55.4073 28.5357 48.1891 23.8248 40.1051 24.8254C32.0323 25.8261 26.6805 36.3724 27.5237 43.1746C27.8723 45.9967 30.537 47.9868 33.4715 47.627C36.406 47.2672 38.5085 44.6813 38.16 41.8704C37.3167 35.0682 29.57 26.1297 21.4973 27.1191C13.4133 28.1085 7.54423 34.4273 8.38749 41.2295C10.1077 55.1826 30.6269 63.5027 35.3604 62.918C40.0938 62.3334 57.9708 49.2798 56.2506 35.338Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9536 43.6918C49.3584 45.7831 50.2129 47.627 51.0224 49.1561C52.4728 51.9557 54.2605 54.5979 56.0032 57.1389C56.9364 58.4993 57.8696 59.871 58.7466 61.2652C59.32 62.1872 60.0621 62.7606 60.9166 62.9967C61.7711 63.2216 62.738 63.0979 63.7387 62.5807C66.5158 61.1753 69.2592 59.7811 72.0251 58.3532C74.9034 56.8691 77.1071 55.4861 78.9847 53.9907C81.2446 52.1806 82.6163 49.8869 83.0773 47.1548C83.5495 44.254 82.7288 41.7242 80.6937 39.8128C77.0284 36.4061 71.8676 35.5066 67.6964 37.4292C65.6388 34.5284 62.5244 32.9094 58.6454 32.7295C55.8458 32.5946 53.6196 33.2692 51.8769 34.7646C50.91 35.5853 50.3253 36.5972 49.8531 37.4068L48.9199 40.6673L48.8524 41.3082C48.7962 42.039 48.785 42.8261 48.9536 43.6918Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep2);
export default __webpack_public_path__ + "static/media/ww-step2.53ac12aa.svg";
export { ForwardRef as ReactComponent };